// Central place for the big-number type. break_infinity.js handles the
// astronomical values an idle game reaches (Edition 10 = 8e12+ Ink and beyond).
import Decimal from 'break_infinity.js'

export { Decimal }
export type D = Decimal
export const ZERO = new Decimal(0)
export const ONE = new Decimal(1)

const UNITS = ['', 'K', 'M', 'B', 'T', 'Qa', 'Qi', 'Sx', 'Sp', 'Oc', 'No', 'Dc']

// Compact display: 1,234 -> "1.23K", scientific past the named tiers.
export function fmt(value: D, decimals = 2): string {
  if (value.lt(1000)) {
    const n = value.toNumber()
    return Number.isInteger(n) ? n.toString() : n.toFixed(decimals)
  }
  const exp = Math.floor(value.log10())
  const tier = Math.floor(exp / 3)
  if (tier < UNITS.length) {
    const scaled = value.div(new Decimal(10).pow(tier * 3))
    return `${scaled.toFixed(decimals)}${UNITS[tier]}`
  }
  return value.toExponential(decimals)
}
